export default function SectionEyebrow({ label, color = "neon", className = "" }) {
  const dot = {
    neon: "bg-ih-neon",
    electric: "bg-ih-electric",
    orange: "bg-ih-orange",
  }[color];
  return (
    <div className={`inline-flex items-center gap-2 px-3 py-1 rounded-full border border-ih-line2 bg-white/[0.02] ${className}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${dot} animate-pulse-glow`} />
      <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-white/70">{label}</span>
    </div>
  );
}
